namespace TabAurous.Administration {
    export interface CampaignSetupRow {
        Id?: number;
        Type?: number;
        Code?: string;
        ProviderType?: string;
        Provider?: number;
        FixedCode?: string;
        AppId?: string;
        ApiKey?: string;
        Token?: string;
        UserName?: string;
        Password?: string;
    }

    export namespace CampaignSetupRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'Administration.CampaignSetup';
        export const lookupKey = 'CSTPR';

        export function getLookup(): Q.Lookup<CampaignSetupRow> {
            return Q.getLookup<CampaignSetupRow>('CSTPR');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Type = "Type",
            Code = "Code",
            ProviderType = "ProviderType",
            Provider = "Provider",
            FixedCode = "FixedCode",
            AppId = "AppId",
            ApiKey = "ApiKey",
            Token = "Token",
            UserName = "UserName",
            Password = "Password"
        }
    }
}
